import styled from "@emotion/styled";
import { Drawer, IconButton, Popper } from "@mui/material";
import { sdkTouchOptimizedStyles } from "scmp-sdk/components/follow-button/styles";

import { theme, ZIndexLayer } from "shared/lib/styles";

import { DashboardDisplay } from "./display";

export const Container = styled.div`
  inline-size: fit-content;

  ${sdkTouchOptimizedStyles}
`;

export const StyledIconButton = styled(IconButton)`
  ${sdkTouchOptimizedStyles}
`;

export const StyledDashboardDisplay = styled(DashboardDisplay)`
  block-size: 100vh;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 300px;
    block-size: 574px;
  }
`;

export const DisplayDrawer = styled(Drawer)`
  z-index: ${ZIndexLayer.Modal};
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const DisplayPopper = styled(Popper)`
  z-index: ${ZIndexLayer.Modal};
  ${sdkTouchOptimizedStyles};
`;

export const MenuContainer = styled.div``;

export const PianoTooltipContainer = styled.div`
  inline-size: 240px;

  color: #ffffff;
  font-size: 16px;
  line-height: 18px;
`;
